// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sn-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  color: var(--primary);
  height: 54px;
  border-radius: 16px;
  cursor: pointer;
  transition: all 0.2s;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border: 1px solid var(--primary);
}
.sn-btn > span {
  font-size: 24px;
  font-weight: 700;
  font-family: Darker Grotesque;
}
.sn-btn:active {
  transform: scale(0.9);
}
.sn-btn-large {
  height: 44px;
  padding: 0 22px;
}
.sn-btn-large > .loading {
  width: 24px;
  height: 24px;
}
.sn-btn-large > span {
  font-size: 16px;
}
.sn-btn-loading {
  cursor: initial;
  pointer-events: none;
  opacity: 0.7;
}
.sn-btn-loading:active {
  transform: scale(1);
}
.sn-btn-loading .loading {
  width: 22px;
  height: 22px;
  animation: rotating 2s linear infinite;
  font-size: 18px;
}
.sn-btn-disabled {
  border-color: #d9d9d9 !important;
  color: rgba(0, 0, 0, 0.25) !important;
  background-color: rgba(0, 0, 0, 0.04) !important;
  cursor: no-drop;
}
.sn-btn-disabled:active {
  transform: scale(1);
}
.sn-btn-primary {
  color: #fff;
  background-color: #000000;
}
.sn-btn:hover,
.sn-btn-primary:active,
.sn-btn-primary:hover,
.sn-btn-primary:focus {
  color: #71E3FF;
  background-color: #000000;
}
.sn-btn-gradient {
  background: linear-gradient(to right, var(--primary), #8060fd);
  border-radius: 16px;
}
.sn-btn-dark {
  background-color: #1C1C27;
  color: #fff;
}
.sn-btn-dark:hover,
.sn-btn-dark:focus {
  background-color: #44425d;
}
/* 
.sn-btn-dark:active {
    background-color: #333246;
} */
@keyframes rotating {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@media screen and (max-width: 768px) {
  .sn-btn-loading .loading {
    margin-right: 4px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Button/style.css"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;EACA,qBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EAKA,oBAAA;EACA,2BAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;EACA,gCAAA;AAHJ;AAMA;EACI,eAAA;EACA,gBAAA;EACA,6BAAA;AAJJ;AAOA;EACI,qBAAA;AALJ;AAQA;EACI,YAAA;EACA,eAAA;AANJ;AASA;EACI,WAAA;EACA,YAAA;AAPJ;AAUA;EACI,eAAA;AARJ;AAWA;EACI,eAAA;EACA,oBAAA;EACA,YAAA;AATJ;AAYA;EACI,mBAAA;AAVJ;AAaA;EACI,WAAA;EACA,YAAA;EACA,sCAAA;EACA,eAAA;AAXJ;AAeA;EACI,gCAAA;EACA,qCAAA;EACA,gDAAA;EACA,eAAA;AAbJ;AAgBA;EACI,mBAAA;AAdJ;AAiBA;EACI,WAAA;EACA,yBAAA;AAfJ;AAkBA;;;;EAII,cAAA;EACA,yBAAA;AAhBJ;AAmBA;EACI,8DAAA;EACA,mBAAA;AAjBJ;AAoBA;EACI,yBAAA;EACA,WAAA;AAlBJ;AAqBA;;EAEI,yBAAA;AAnBJ;AACA;;;GAGG;AAwBH;EACI;IACI,oBAAA;EAtBN;EAyBE;IACI,yBAAA;EAvBN;AACF;AA0BA;EACI;IACI,iBAAA;EAxBN;AACF","sourcesContent":[".sn-btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: transparent;\n    color: var(--primary);\n    height: 54px;\n    border-radius: 16px;\n    cursor: pointer;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    transition: all .2s;\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    border: 1px solid var(--primary);\n}\n\n.sn-btn>span {\n    font-size: 24px;\n    font-weight: 700;\n    font-family: Darker Grotesque;\n}\n\n.sn-btn:active {\n    transform: scale(.9);\n}\n\n.sn-btn-large {\n    height: 44px;\n    padding: 0 22px;\n}\n\n.sn-btn-large>.loading {\n    width: 24px;\n    height: 24px;\n}\n\n.sn-btn-large>span {\n    font-size: 16px\n}\n\n.sn-btn-loading {\n    cursor: initial;\n    pointer-events: none;\n    opacity: .7;\n}\n\n.sn-btn-loading:active {\n    transform: scale(1);\n}\n\n.sn-btn-loading .loading {\n    width: 22px;\n    height: 22px;\n    animation: rotating 2s linear infinite;\n    font-size: 18px\n}\n\n\n.sn-btn-disabled {\n    border-color: #d9d9d9 !important;\n    color: rgba(0, 0, 0, .25) !important;\n    background-color: rgba(0,0,0,.04) !important;\n    cursor: no-drop\n}\n\n.sn-btn-disabled:active {\n    transform: scale(1);\n}\n\n.sn-btn-primary {\n    color: #fff;\n    background-color: #000000;\n}\n\n.sn-btn:hover,\n.sn-btn-primary:active,\n.sn-btn-primary:hover,\n.sn-btn-primary:focus {\n    color: #71E3FF;\n    background-color: #000000;\n}\n\n.sn-btn-gradient {\n    background: linear-gradient(to right, var(--primary), #8060fd);\n    border-radius: 16px;\n}\n\n.sn-btn-dark {\n    background-color: #1C1C27;\n    color: #fff\n}\n\n.sn-btn-dark:hover,\n.sn-btn-dark:focus {\n    background-color: #44425d;\n}\n\n/* \n.sn-btn-dark:active {\n    background-color: #333246;\n} */\n\n\n@keyframes rotating {\n    from {\n        transform: rotate(0);\n    }\n\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n@media screen and (max-width: 768px) {\n    .sn-btn-loading .loading {\n        margin-right: 4px\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
